export { default as homeMagazine } from '@handlebars/home-magazine.hbs';
export { default as homeMagazineItem } from '@handlebars/home-magazine-item.hbs';
export { default as homeMagazineList } from '@handlebars/home-magazine-list.hbs';
export { default as magazineArticle } from '@handlebars/magazine-article.hbs';
export { default as magazineArticleList } from '@handlebars/magazine-article-list.hbs';
export { default as magazineBtn } from '@handlebars/magazine-btn.hbs';
export { default as magazineFooterBtn } from '@handlebars/magazine-footer-btn.hbs';
export { default as magazineForm } from '@handlebars/magazine-form.hbs';
export { default as magazineFormTag } from '@handlebars/magazine-form-tag.hbs';
export { default as magazineRequestList } from '@handlebars/magazine-request-list.hbs';
export { default as mobileHomeMagazineItem } from '@handlebars/mobile/home-magazine-item.hbs';
